import {
  REDUCER_NAMES_ACK_INBOUND_SHIPMENTS_REMINDER_POPUP as defaultSlice,
} from '../../constants'


export const getHasAckInboundShipmentsReminderPopupHadChanceToRender = (state, customerId) => (
  state[defaultSlice].hasHadChanceToRender[customerId] || false
)
